import React from "react";
import { Typography, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { selectInvitationState } from "../../sagas/invitations/invitationSlice";
import { ResidentpageState } from '../../ResidentpageState';
import { selectAuthState } from '../../../sagas/auth/authSlice';

export default function Notification(props: {pageState: ResidentpageState}) {
  const getNotification = (text: string, style?: {}) => (
    <Box sx={{ margin: '60px 0 100px', padding: '0 20px' }}>
      <Typography
        style={{
          maxWidth: "420px",
          margin: "0 10px",
          background: " #F1F0F5",
          borderRadius: " 24px",
          fontSize: '12px',
          padding: "15px",
          ...style,
        }}
      >
        {text}
      </Typography>
    </Box>
  );

  const getEmphasizedNotification = (text: string, style?: {}) => (
    <Box sx={{ margin: '80px 0', padding: '0 20px' }}>
      <Typography
        style={{
          maxWidth: "435px",
          margin: "0 10px",
          borderTop: "2px  solid #DB3939",
          borderRadius: " 24px",
          padding: "7px 20px",
          fontSize: '12px',
          color: '#DB3939',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          ...style,
        }}
      >
        {text}
      </Typography>
    </Box>
  );

  const { isSearchingResidentSucceed, residentResponse, isSearchingResidentFailed, residentErrorResponse, isSearchingPropertySucceed, propertyResponse, isSearchingPropertyFailed } = useSelector(selectInvitationState);
  const { validateTokenErrorResponse } = useSelector(selectAuthState);

  return props.pageState === ResidentpageState.SearchResidentByEmail && isSearchingResidentFailed && residentErrorResponse?.statusCode !== 409 ? (
    getEmphasizedNotification("We weren't able to locate that email. Try another email, search by address, or contact your property manager.")
  ) : props.pageState === ResidentpageState.SearchResidentByEmail && isSearchingResidentFailed && residentErrorResponse?.statusCode === 409 ? (
    getEmphasizedNotification('The account(s) associated with this email address are already registered.')
  ) : props.pageState === ResidentpageState.SearchResidentByEmail && isSearchingResidentSucceed ? (
    getNotification("We found you!. Please check your email and follow the link.")
  ) : props.pageState === ResidentpageState.SearchPropertiesByAddress && isSearchingPropertySucceed && propertyResponse?.properties?.length === 0 ? (
    getEmphasizedNotification("This address could not be located. Please try a different address or contact your Property Manager or support.")
  ) : props.pageState === ResidentpageState.SearchResidentsByPuuidAndName && isSearchingResidentSucceed && residentResponse?.residents?.length === 0 ? (
    getEmphasizedNotification("A resident with this name could not be located. Please try a different name or contact your Property Manager.")
  ) : props.pageState === ResidentpageState.SearchResidentsByPuuidAndName && isSearchingResidentFailed && residentErrorResponse?.statusCode === 403 ? (
    getEmphasizedNotification("Your search session has expired. Please start over.")
  ) : isSearchingResidentFailed || isSearchingPropertyFailed ? (//unkown error handling
    getEmphasizedNotification("Something went wrong.")
  ) : props.pageState === ResidentpageState.SearchSpecialCode && validateTokenErrorResponse?.statusCode === 403 ? (
    getEmphasizedNotification("The special code supplied has already been used. If you feel this is an error, please contact support.")
  ) : props.pageState === ResidentpageState.SearchSpecialCode && validateTokenErrorResponse?.message ? (
    getEmphasizedNotification("Invalid special code")
  ) : (
    <></>
  );
}
